import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { KeysScreen } from "../../screens/settings/KeysScreen.tsx";

/** `/settings/keys`: API keys for the company's own tools, and (for administrators) webhooks. */
export const Route = createFileRoute("/_app/settings/keys")({
  // webhooks are their own tab (administrators)
  validateSearch: (search: Record<string, unknown>): { tab?: "webhooks" } =>
    search.tab === "webhooks" ? { tab: "webhooks" } : {},
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("apiKeys.list", {})),
  component: KeysScreen,
});
